export interface Login {
  login: string;
  password: string;
}

export interface LoginWithCode {
  grant_type: 'authorization_code';
  authorization_code: string;
  role: 4;
}

export interface Email {
  email: string;
}

export interface RecoveryPassword {
  token: string;
  new_password: string;
  new_password_confirm: string;
}

export interface ChangePassword {
  password: string;
  new_password: string;
  new_password_confirm: string;
}

export interface AuthGroup {
  description: string;
  id: number;
  name: string;
}

export interface AuthUserName {
  first_name: string;
  last_name: string;
  patronymic_name: string;
}

export interface AuthDataInterface {
  isLoggedIn?: boolean;
  days_left: number;
  permissions: string[];
  groups: AuthGroup[];
  employee: AuthUserName;
  current_group: AuthGroup;
  u_id: number | null;
  is_privileged: boolean;
  is_brigadier: boolean;
  session_id: string;
  loggedByMobileId: boolean;
}

export interface ChangeRole {
  group_id: string | number;
}

export interface CheckValidToken {
  login: string;
}

export interface ADFSStorage {
  login: string;
}

export interface ADFSSettings {
  adfs_auth_enable: boolean;
  adfs_domain: string;
  adfs_pwd_reset_url: string;
}

export const AUTH_PATHS = {
  login: 'auth/login',
  logout: 'auth/logout',
  login_callback: 'auth/login/callback',
  login_legacy: 'auth/login-legacy',
  recovery_access: 'auth/recovery_access',
  send_email_success: 'auth/recovery_access/send_email_success',
  change_password: 'auth/recovery_access/change_password/:token',
  change_password_incorrect: 'auth/recovery_access/change_password_incorrect',
  change_password_success: 'auth/recovery_access/change_password_success',
};
